import type { IconType } from "@memorang/ui";

const lucideToMdiMap: Record<string, IconType> = {
	bot: "robot-outline",
	"book-open": "book-open-variant",
	"brain-circuit": "head-cog-outline",
	"chart-column-increasing": "chart-bar",
	"circle-play": "play-circle-outline",
	"clipboard-check": "clipboard-check-outline",
	clock: "clock-outline",
	compass: "compass-outline",
	"eye-off": "eye-off-outline",
	"list-checks": "format-list-checks",
	"messages-square": "forum-outline",
	scale: "scale-balance",
	"scan-search": "magnify-scan",
	"shield-alert": "shield-alert",
	"shield-check": "shield-check-outline",
	"square-pen": "note-edit-outline",
	"trash-2": "trash-can-outline",
};

export const lucideToMdiIcon = (
	name: string | undefined,
	fallback: IconType = "checkbox-marked-outline",
): IconType => (name ? (lucideToMdiMap[name] ?? fallback) : fallback);
